import { render, staticRenderFns } from "./InstructionPackageDetail.vue?vue&type=template&id=03831622&scoped=true"
import script from "./InstructionPackageDetail.vue?vue&type=script&lang=js"
export * from "./InstructionPackageDetail.vue?vue&type=script&lang=js"
import style0 from "./InstructionPackageDetail.vue?vue&type=style&index=0&id=03831622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03831622",
  null
  
)

export default component.exports